import request from '../request'

// 获取正装模板列表
export const getPhotoTemplateData = () => {
	return request({
		url: `v3/photo/id_photo_template`,
		method: 'get'
	})
}

// 获取可制作证件照次数
export const getUsePhotoCount = () => {
	return request({
		url: `/v3/photo/id_photo_count`,
		method: 'get'
	})
}

// 获取上传的证件照原图 检查照片是否上传完成
export const getUserUploadPhoto = (photoKey) => {
	return request({
		url: `/v3/photo/${photoKey}`,
		method: 'get'
	})
}

// 制作并检测证件照 换底色，美颜，换正装
export const editPhotoBeauty = (data) => {
	return request({
		url: `/v3/photo/cut_check_pic`,
		method: 'post',
    data
	})
}

// 获取无水印证件照
export const getNoWatermarkedPhoto = (data) => {
	return request({
		url: `/v3/photo/take_cut_pic`,
		method: 'post',
    data
	})
}

// 创建购买证件照订单
export const createPhotoBeautyOrder = () => {
	return request({
		url: `/v3/orders/id_photo_orders`,
		method: 'post'
	})
}

// 检查订单支付状态
export const checkOrderStatus= (orderId) => {
	return request({
		url: `/v3/orders/check/${orderId}`,
		method: 'get'
	})
}
